import type { TranslationInterface } from '.';

export const GreekLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Γράψτε ένα μήνυμα...',
  your_issue_has_been_resolved: 'Το πρόβλημά σας επιλύθηκε!',
  new_conversation: 'Νέα συνομιλία',
  welcome_screen_title: 'Καλώς ήρθατε στη συνομιλία υποστήριξης',
  welcome_screen_description:
    'Είμαστε εδώ για να βοηθήσουμε! Ξεκινήστε μια συνομιλία και θα σας απαντήσουμε το συντομότερο δυνατό.',
  your_name_placeholder: 'Το όνομά σας',
  your_email_placeholder: 'Η διεύθυνση email σας',
  start_chat_button: 'Επικοινωνία με την υποστήριξη',
  start_chat_button_loading: 'Σύνδεση...',
  i_need_more_help: 'Χρειάζομαι περισσότερη βοήθεια',
  this_was_helpful: 'Αυτό ήταν χρήσιμο',
  optional: 'Προαιρετικό',
  no_conversations_yet: 'Δεν υπάρχουν συνομιλίες ακόμα',
  back_to_conversations: 'Πίσω στις συνομιλίες',
  closed_conversations: 'Κλειστές συνομιλίες',
  csat_title: 'Πώς ήταν η συνομιλία σας;',
  csat_submitted_title: 'Βαθμολογήσατε τη συνομιλία ως',
  csat_feedback_placeholder: 'Πείτε μας περισσότερα... (προαιρετικό)',
  follow_up_placeholder: 'Συνέχεια…',
  companion_layout_label: 'Διάταξη',
  companion_layout_floating: 'Αιωρούμενο',
  companion_layout_sidebar: 'Πλευρική στήλη',
  companion_layout_fullscreen: 'Πλήρης οθόνη',
  companion_close: 'Κλείσιμο',
  companion_history: 'Ιστορικό συνομιλιών',
  companion_expand_chat: 'Ανάπτυξη συνομιλίας',
  companion_sidebar_dock_label: 'Αγκύρωση',
  companion_sidebar_side_label: 'Πλευρά',
  companion_sidebar_left: 'Αριστερά',
  companion_sidebar_right: 'Δεξιά',
  companion_resize_chat: 'Αλλαγή μεγέθους συνομιλίας',
  scroll_to_bottom: 'Κύλιση στο τέλος',
  thinking: 'Σκέψη…',
  running: 'Εκτελείται…',
  steps: 'βήματα',
  step_arguments: 'Ορίσματα',
  step_result: 'Αποτέλεσμα',
  attach_files:
    'Επισύναψη εικόνων, βίντεο, PDF ή υπολογιστικών φύλλων (μέγιστο μέγεθος 25 MB)',
  mark_page_active:
    'Κάντε κλικ σε οτιδήποτε στη σελίδα για να το επισημάνετε — Esc για ακύρωση',
  mark_page: 'Επισημάνετε κάτι στη σελίδα για να ρωτήσετε σχετικά με αυτό',
  stop_response: 'Διακοπή απάντησης',
  copy_reply: 'Αντιγραφή απάντησης',
  mentions_empty: 'Δεν βρέθηκαν αποτελέσματα',
  copied: 'Αντιγράφηκε',
  send_message: 'Αποστολή μηνύματος',
  upload_failed: 'Η μεταφόρτωση απέτυχε: {error}',
  remove_attachment: 'Αφαίρεση συνημμένου',
  json_no_items: 'Δεν υπάρχουν στοιχεία',
  json_no_data: 'Δεν υπάρχουν δεδομένα',
  json_no_chart_data: 'Δεν υπάρχουν δεδομένα για γράφημα',
  json_unsupported: 'Δεν υποστηρίζεται: {type}',
  json_see_less: 'Εμφάνιση λιγότερων',
  json_phone_agent: 'Τηλεφωνικός πράκτορας',
  json_phone_agent_test: 'Δοκιμή μέσω web',
  page_context_remove: 'Αφαίρεση περιβάλλοντος σελίδας',
  json_see_more: 'Εμφάνιση {count} ακόμη',
  queued_label: '{count} Σε αναμονή',
  remove_queued_message: 'Αφαίρεση μηνύματος από την ουρά',
  send_queued_now: 'Αποστολή μηνυμάτων ουράς τώρα',
  turn_failed_message: 'Κάτι πήγε στραβά και η απάντηση δεν έφτασε.',
  turn_failed_retry: 'Δοκιμάστε ξανά',
  page_mark_hint: 'Κάντε κλικ σε κάτι για να το επισημάνετε',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Πλαίσιο',
  page_mark_shape_circle: 'Κύκλος',
  page_mark_shape_arrow: 'Βέλος',
  page_mark_shape_bracket: 'Αγκύλη',
  page_mark_shape_underline: 'Υπογράμμιση',
  page_mark_shape_highlight: 'Επισήμανση',
  page_mark_shape_strike_through: 'Διακριτή διαγραφή',
  page_mark_shape_crossed_off: 'Χιαστή διαγραφή',
  page_mark_shape_aria: 'Σχήμα επισήμανσης: {shape}',
  page_mark_note_placeholder: 'Προσθέστε σημείωση… (Enter για επισύναψη)',
  page_mark_attach: 'Επισύναψη επισήμανσης',
  page_mark_remove: 'Αφαίρεση {label}',
  page_mark_region: 'Επισημασμένη περιοχή',
  page_mark_default_message: 'Τι είναι αυτό;',
  file_rejected:
    'Ο τύπος αρχείου δεν υποστηρίζεται ή το αρχείο είναι πολύ μεγάλο.',
  dictate: 'Υπαγόρευση',
  stop_dictation: 'Διακοπή υπαγόρευσης',
  dictation_mic_blocked: 'Επιτρέψτε την πρόσβαση στο μικρόφωνο για υπαγόρευση',
  dictation_unavailable: 'Η υπαγόρευση δεν είναι διαθέσιμη αυτή τη στιγμή',
  questions_back: 'Πίσω',
  questions_next: 'Επόμενο',
  questions_send: 'Αποστολή',
  questions_type_answer: 'Θα το γράψω',
  questions_answer_placeholder: 'Γράψτε την απάντησή σας…',
  close_conversation_title: 'Κλείσιμο συνομιλίας',
  close_conversation_description:
    'Είστε βέβαιοι ότι θέλετε να κλείσετε αυτήν τη συνομιλία;',
  close_conversation_cancel: 'Όχι',
  close_conversation_confirm: 'Ναι',
  dialog_close: 'Κλείσιμο',
  zoom_in: 'Μεγέθυνση',
  zoom_out: 'Σμίκρυνση',
  reset_zoom: 'Επαναφορά ζουμ',
  support_chat_aria_label: 'Συνομιλία υποστήριξης',
};
